// src/features/orders/warehouseSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Staff type
export interface Warehouse {
  id: string;
  [key: string]: any; // flexible, allow extra fields from API
}

// API response shape for data
interface WarehouseListResponse  {
  warehouses: Warehouse[];
  deactivatedWarehouses?: Warehouse[];
  total: number;
  page: number;
  totalPages: number;
}

// Slice state
interface WarehouseState {
  data: WarehouseListResponse  | null;
  loading: boolean;
  error: string | null;
}

// Payload for updating a warehouse
export interface warehouseUpdatePayload {
  id: string;
  [key: string]: any;
}

// ✅ Initial state
const initialState: WarehouseState = {
  data: null,
  loading: false,
  error: null,
};

// ✅ Slice
const warehouseSlice = createSlice({
  name: "warehouse",
  initialState,
  reducers: {
    // Set full warehouse data response
    setWarehouseList(state, action: PayloadAction<WarehouseListResponse >) {
      state.data = action.payload;
      state.loading = false;
    },

    // Add a new warehouse
    addWarehouse(state, action: PayloadAction<Warehouse>) {
      // console.log(action,"ACTIONACTIONACTIONACTIONACTION")
      // 1. The payload **is** the Warehouse object
      const newWarehouseRaw = action.payload;

      // 2. Normalise it (same as before, but use the raw payload)
      // const newWarehouse: Warehouse = {
      //   id: newWarehouseRaw.id ?? "",
      //   status: newWarehouseRaw.status ?? "ACTIVE",
      //   name: newWarehouseRaw.name ?? "",
      //   country: newWarehouseRaw.country ?? "",
      //   city: newWarehouseRaw.city ?? "",
      //   district: newWarehouseRaw.district ?? "",
      //   zipCode: newWarehouseRaw.zipCode ?? "",
      //   shortAddress: newWarehouseRaw.shortAddress ?? "",
      //   location: newWarehouseRaw.location ?? "",
      // };

      // 3. Insert into the list (unchanged)
      if (state.data?.warehouses) {
        state?.data?.warehouses?.unshift(newWarehouseRaw);
        state.data.total += 1;
        if (state?.data?.warehouses?.length > 10) state?.data?.warehouses?.pop();
      } else {
        state.data = {
          warehouses: [newWarehouseRaw],
          total: 1,
          page: 1,
          totalPages: 1,
        };
      }
    },
    // Update warehouse by id
    warehouseUpdate(state, action: PayloadAction<warehouseUpdatePayload>) {
      console.log(action, "acitons");
      const { id, ...updates } = action.payload;
      console.log(id, "id");
      if (!id || !state.data) return;

      console.log(state.data, "data");
      const warehouse = state.data.warehouses.find((p) => p.id === id);
      if (warehouse) {
        Object.assign(warehouse, updates);
      }
    },

    // Set loading state
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },

    // Set error state
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
  },
});

// ✅ Export actions
export const { setWarehouseList, addWarehouse, warehouseUpdate, setLoading, setError } =
  warehouseSlice.actions;

// ✅ Export reducer
export default warehouseSlice.reducer;
